import { HTTP_CP_SignUp_Request_SmartSearch, HTTP_CP_SignUp_Request_SmartSearchCase } from '@api-new/authservice';
import {
  ENUM_MortgagePartStepType,
  ENUM_PropertyInvestmentType,
  ENUM_SmartSearchBuyPropertyType,
  ENUM_SmartSearchRemortgageReason,
  ENUM_SmartSearchRemortgageType,
} from '@api-new/common';
import { SmartSearchFormValues } from '@shared-lib/forms/sign-up-smart-search/smart-search.form';
import { SmartSearchBasicDataModel } from '@shared/store/sign-up/models/smart-search-basic-data.model';
import { signUpPropertyBuyAdapter } from './sign-up-property.adapter';

export const signUpSmartSearchBasicDataAdapter = (values: SmartSearchFormValues | null): SmartSearchBasicDataModel => {
  return {
    includeInitialRateTypeFixed: !!values?.initialRate.initialInterestRateType.includes(
      ENUM_MortgagePartStepType.MORTGAGE_PART_STEP_TYPE_FIXED,
    ),
    includeInitialRateTypeVariable: !!values?.initialRate.initialInterestRateType.includes(
      ENUM_MortgagePartStepType.MORTGAGE_PART_STEP_TYPE_VARIABLE,
    ),
    minimumInitialRatePeriodInMonths: (values?.initialRate?.comparisonPeriod?.[0] ?? 0) * 12,
    maximumInitialRatePeriodInMonths: (values?.initialRate?.comparisonPeriod?.[1] ?? 0) * 12,
  };
};

export const signUpSmartSearchBuyPropertyToHttpRequestAdapter = (
  smartSearch: SmartSearchFormValues | null | undefined,
  data: SmartSearchBasicDataModel,
  propertyType: ENUM_SmartSearchBuyPropertyType,
  investmentType: ENUM_PropertyInvestmentType,
): HTTP_CP_SignUp_Request_SmartSearch | undefined => {
  if (!smartSearch) return undefined;
  return {
    ...data,
    buyProperty: signUpPropertyBuyAdapter(smartSearch, propertyType, investmentType),
  };
};

export const signUpSmartSearchRemortgageToHttpRequestAdapter = (
  smartSearch: SmartSearchFormValues | null | undefined,
  data: SmartSearchBasicDataModel,
  hasMortgage: boolean,
): HTTP_CP_SignUp_Request_SmartSearch | undefined => {
  if (!smartSearch) return undefined;
  return {
    ...data,
    remortgage: {
      lenderId: smartSearch.liveResults.lenderId ?? undefined,
      smartSearchRemortgageType: ENUM_SmartSearchRemortgageType.SMART_SEARCH_REMORTGAGE_TYPE_LIKE_FOR_LIKE,
      smartSearchRemortgageReason: ENUM_SmartSearchRemortgageReason.SMART_SEARCH_REMORTGAGE_REASON_LIKE_FOR_LIKE,
      mortgage: hasMortgage
        ? undefined
        : {
            loanAmount: smartSearch.loanAmount,
            termInMonths: smartSearch.basicDetails.newTermInMonths,
            mortgageRepaymentType: smartSearch.liveResults.repaymentType,
          },
    },
  };
};

export const signUpSmartSearchCaseToHttpRequestAdapter = (
  smartSearch: SmartSearchFormValues | null,
): HTTP_CP_SignUp_Request_SmartSearchCase | undefined => {
  return !smartSearch?.mortgageProductId
    ? undefined
    : {
        mortgageProductId: smartSearch.mortgageProductId,
      };
};
